// @flow
import _ from 'lodash';
import {
  CSATRatingAction,
  CSATRatingState,
  GET_CSAT_RATING_REQUEST,
  GET_CSAT_RATING_SUCCESS,
  GET_CSAT_RATING_FAILURE,
  UPDATE_CSAT_RATING_REQUEST,
  UPDATE_CSAT_RATING_SUCCESS,
  UPDATE_CSAT_RATING_FAILURE,
  RATING_TYPE,
} from 'stores/flow-type/csat-rating.type';

const initialState: CSATRatingState = {
  csatRating: [],
  obRating: null,
  dashboardRating: null,
  getCSATRatingLoading: false,
  getCSATRatingSuccess: false,
  error: null,

  updateCSATRatingLoading: false,
  updateCSATRatingSuccess: false
};

const csatRatingReducers = (
  state: CSATRatingState = initialState,
  action: CSATRatingAction
) => {
  const { type } = action;

  switch (type) {
    case GET_CSAT_RATING_REQUEST:
      return {
        ...state,
        getCSATRatingLoading: true,
        getCSATRatingSuccess: false,
        error: null,
      };
    case GET_CSAT_RATING_SUCCESS: {
      const { data } = action.payload;
      const csatRating = data?.csatRating || []

      const obRating = _.find(csatRating, (item) => item.type === RATING_TYPE.ONBOARDING)
      const dashboardRating = _.find(csatRating, (item) => item.type === RATING_TYPE.DASHBOARD)

      return {
        ...state,
        csatRating: data,
        obRating,
        dashboardRating,
        getCSATRatingLoading: false,
        getCSATRatingSuccess: true,
        error: null,
      };
    }
    case GET_CSAT_RATING_FAILURE:
      return {
        ...state,
        getCSATRatingLoading: false,
        getCSATRatingSuccess: false,
        error: action.payload
      };

    case UPDATE_CSAT_RATING_REQUEST:
      return {
        ...state,
        updateCSATRatingLoading: true,
        updateCSATRatingSuccess: false,
        error: null,
      };
    case UPDATE_CSAT_RATING_SUCCESS: {
      const { data } = action.payload;
      const payload = {
        ...state,
        updateCSATRatingLoading: false,
        updateCSATRatingSuccess: true,
        error: null,
      }
      if (data?.type === RATING_TYPE.DASHBOARD) {
        payload.dashboardRating = data
      }
      else if (data?.type === RATING_TYPE.ONBOARDING) {
        payload.obRating = data
      }

      return payload
    }
    case UPDATE_CSAT_RATING_FAILURE:
      return {
        ...state,
        updateCSATRatingLoading: false,
        updateCSATRatingSuccess: false,
        error: action.payload
      };
    default:
      return state;
  }
};

export default csatRatingReducers;
